/******************************************************************
Author: BesLogic (http://www.beslogic.com/)
Description: Custom javascript for a theme matching the marmara template
******************************************************************/
$(function() {

  $('.menu.center > li:nth-child(3)').hover(function(){
    if($('.menu.center > li:nth-child(2)').children('a').hasClass('active')) {
     	 $('.menu li:nth-child(2) .dropdown').addClass('sub-menu_hide');
    }    
  }, function(){
  	if($('.menu.center > li:nth-child(2)').children('a').hasClass('active')) {
     	 $('.menu li:nth-child(2) .dropdown').removeClass('sub-menu_hide');
    }
  });
  
  $('.menu.center > li:nth-child(2)').hover(function(){
    if($('.menu.center > li:nth-child(3)').children('a').hasClass('active')) {
     	 $('.menu li:nth-child(3) .dropdown').addClass('sub-menu_hide');
    }    
  }, function(){
  	if($('.menu.center > li:nth-child(3)').children('a').hasClass('active')) {
     	 $('.menu li:nth-child(3) .dropdown').removeClass('sub-menu_hide');
    }
  });
    
});

